var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 19.5H3.75C1.68225 19.5 0 17.8177 0 15.75V3.75C0 1.68225 1.68225 0 3.75 0H6.25C8.31775 0 10 1.68225 10 3.75V15.75C10 17.8177 8.31775 19.5 6.25 19.5ZM3.75 2.5C3.06075 2.5 2.5 3.06075 2.5 3.75V15.75C2.5 16.4392 3.06075 17 3.75 17H6.25C6.93925 17 7.5 16.4392 7.5 15.75V3.75C7.5 3.06075 6.93925 2.5 6.25 2.5H3.75Z",
    fill: "#8E918F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 32H3.75C1.68225 32 0 30.3177 0 28.25V25.75C0 23.6823 1.68225 22 3.75 22H15.75C17.8177 22 19.5 23.6823 19.5 25.75V28.25C19.5 30.3177 17.8177 32 15.75 32ZM3.75 24.5C3.06075 24.5 2.5 25.0608 2.5 25.75V28.25C2.5 28.9392 3.06075 29.5 3.75 29.5H15.75C16.4392 29.5 17 28.9392 17 28.25V25.75C17 25.0608 16.4392 24.5 15.75 24.5H3.75Z",
    fill: "#8E918F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.25 32H25.75C23.6823 32 22 30.3177 22 28.25V25.75C22 23.6823 23.6823 22 25.75 22H28.25C30.3177 22 32 23.6823 32 25.75V28.25C32 30.3177 30.3177 32 28.25 32ZM25.75 24.5C25.0608 24.5 24.5 25.0608 24.5 25.75V28.25C24.5 28.9392 25.0608 29.5 25.75 29.5H28.25C28.9392 29.5 29.5 28.9392 29.5 28.25V25.75C29.5 25.0608 28.9392 24.5 28.25 24.5H25.75Z",
    fill: "#8E918F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.25 19.5H16.25C14.1823 19.5 12.5 17.8177 12.5 15.75V3.75C12.5 1.68225 14.1823 0 16.25 0H28.25C30.3177 0 32 1.68225 32 3.75V15.75C32 17.8177 30.3177 19.5 28.25 19.5ZM16.25 2.5C15.5608 2.5 15 3.06075 15 3.75V15.75C15 16.4392 15.5608 17 16.25 17H28.25C28.9392 17 29.5 16.4392 29.5 15.75V3.75C29.5 3.06075 28.9392 2.5 28.25 2.5H16.25Z",
    fill: "#8E918F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.295e0dad984db4d6e9bbb238b485b7b7.svg";
export { ForwardRef as ReactComponent };